import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IOption } from './button-radio-group-option.model';

@Component({
  selector: 'kh-button-radio-group',
  templateUrl: './button-radio-group.component.html',
  styleUrls: ['./button-radio-group.component.less'],
  standalone: false
})
export class ButtonRadioGroupComponent {
  @Input()
  public options?: IOption[];

  @Input()
  public value: any = null;

  @Input()
  public label: string | null = null;

  @Output()
  public valueChange = new EventEmitter<any>();

  public notifyChanged(): void {
    this.valueChange.next(this.value);
  }

  public get accessibleLabel(): string {
    return this.options?.map((option) => option.label).join(', ') || '';
  }

  public getOptionTabindex(option: IOption): 0 | -1 {
    return this.isSelected(option) || (!this.value && option === this.options?.[0]) ? 0 : -1;
  }

  public isSelected(option: IOption): boolean {
    return this.value === option.value;
  }
}
